import { Link } from "react-router-dom";

const iconClass = "h-3.5 w-3.5";

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={iconClass}>
      <path d="M12 2.2c3.2 0 3.6 0 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s0 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58 0-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.21 15.58 2.2 15.2 2.2 12s0-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.21 8.8 2.2 12 2.2Zm0 1.8c-3.15 0-3.5 0-4.74.07-1.07.05-1.65.23-2.04.38-.51.2-.88.44-1.27.83-.39.39-.63.76-.83 1.27-.15.39-.33.97-.38 2.04C2.67 8.83 2.66 9.18 2.66 12s0 3.17.07 4.41c.05 1.07.23 1.65.38 2.04.2.51.44.88.83 1.27.39.39.76.63 1.27.83.39.15.97.33 2.04.38C8.5 21 8.85 21 12 21s3.5 0 4.74-.07c1.07-.05 1.65-.23 2.04-.38.51-.2.88-.44 1.27-.83.39-.39.63-.76.83-1.27.15-.39.33-.97.38-2.04.06-1.24.07-1.59.07-4.41s0-3.17-.07-4.41c-.05-1.07-.23-1.65-.38-2.04a3.4 3.4 0 0 0-.83-1.27 3.4 3.4 0 0 0-1.27-.83c-.39-.15-.97-.33-2.04-.38C15.5 4 15.15 4 12 4Zm0 3.05a4.95 4.95 0 1 1 0 9.9 4.95 4.95 0 0 1 0-9.9Zm0 1.8a3.15 3.15 0 1 0 0 6.3 3.15 3.15 0 0 0 0-6.3Zm5.15-2.04a1.16 1.16 0 1 1 0 2.32 1.16 1.16 0 0 1 0-2.32Z" />
    </svg>
  );
}

function TikTokIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={iconClass}>
      <path d="M16.6 5.82a4.28 4.28 0 0 1-1.05-2.82H12.5v12.43a2.5 2.5 0 1 1-1.78-2.4V9.84a5.55 5.55 0 1 0 4.82 5.5V9.4a7.3 7.3 0 0 0 4.46 1.5V7.83a4.28 4.28 0 0 1-3.4-2.01Z" />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={iconClass}>
      <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.45 2.89h-2.33v6.99A10 10 0 0 0 22 12Z" />
    </svg>
  );
}

const SOCIALS = [
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@nexafx23?is_from_webapp=1&sender_device=pc",
    Icon: TikTokIcon,
  },
  {
    name: "Facebook",
    href: null,
    Icon: FacebookIcon,
  },
];

export function SiteFooter() {
  return (
    <footer className="mt-10 border-t border-border/60 px-6 py-6 lg:px-10">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 text-[11px] font-light text-muted-foreground sm:flex-row sm:justify-between">
        <p className="text-center sm:text-left">
          Secure payments ·{" "}
          <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
          {" · "}
          <Link to="/privacy-policy" className="hover:text-foreground transition-colors">Privacy</Link>
        </p>
        <div className="flex items-center gap-3">
          {SOCIALS.filter((s) => s.href).map(({ name, href, Icon }) => (
            <a
              key={name}
              href={href as string}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={name}
              className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-border/60 text-muted-foreground hover:text-foreground hover:border-foreground/40 transition-colors"
            >
              <Icon />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
